module.exports = __webpack_public_path__ + "static/media/mandy-lose.4b93adc4.png";